import { Clock, MessageSquare, FileX, RotateCcw } from "lucide-react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

export const ProblemSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const problems = [
    {
      icon: Clock,
      title: "20+ Hours Wasted Weekly",
      description: "Writing repetitive handoff docs manually steals your creative time",
      size: "large",
      delay: 0.1,
    },
    {
      icon: MessageSquare,
      title: "Endless Developer Questions",
      description: "Missing specs cause constant back-and-forth communication",
      size: "small",
      delay: 0.2,
    },
    {
      icon: FileX,
      title: "Outdated Documentation",
      description: "Docs become obsolete after every design iteration",
      size: "small",
      delay: 0.3,
    },
    {
      icon: RotateCcw,
      title: "Repeated Work",
      description: "Recreating docs for every project and every client handoff",
      size: "large",
      delay: 0.4,
    },
  ];

  return (
    <section className="section-padding bg-gradient-to-b from-background to-muted/20" ref={ref}>
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            The <span className="gradient-text">Documentation Struggle</span> is Real
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Designers waste countless hours on handoff documentation that quickly becomes outdated
          </p>
        </motion.div>

        {/* Bento Grid Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {problems.map((problem, index) => {
            const Icon = problem.icon;
            return (
              <motion.div
                key={problem.title}
                initial={{ opacity: 0, y: 30 }}
                animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
                transition={{ duration: 0.5, delay: problem.delay }}
                className="glass-card p-8 hover-glow hover-lift"
              >
                <div className="flex flex-col h-full">
                  <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#667eea]/20 to-[#764ba2]/20 flex items-center justify-center mb-6">
                    <Icon className="h-7 w-7 text-primary" />
                  </div>
                  <h3 className="text-2xl font-bold mb-3">{problem.title}</h3>
                  <p className="text-muted-foreground text-lg">{problem.description}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
